var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border text-primary",class:{
	'spinner-border-sm': _vm.small,
	'spinner-border-xs': _vm.xsmall,
},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Chargement ...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }